export const SET_PATIENT_ID = "SET_PATIENT_ID";
export const SET_SLIDE = "SET_SLIDE";
export const SET_CHAT_COUNT = "SET_CHAT_COUNT";
export const SET_DIET_COUNT = "SET_DIET_COUNT";